export default __webpack_public_path__ + "static/media/lesMillsBlack.6c94b44a.svg";